import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { urlApi } from '../../../utils/apiConfig';

@Injectable()
export class ClinicorpMenuService {
  constructor(private http: HttpClient) {}

  public listarClinicas(): Observable<any> {
    return this.http.get(urlApi + '/app/clinicorp/config');
  }

  public cadastrarClinica(payload: any): Observable<any> {
    return this.http.post(urlApi + '/app/clinicorp/config', payload);
  }

  public atualizarClinica(payload: any): Observable<any> {
    return this.http.patch(urlApi + '/app/clinicorp/config', payload);
  }

  public buscarBusinessPorSubscriber(subscriberId: string, token: string): Observable<any> {
    return this.http.post(urlApi + '/clinicorp/business/list', { subscribeId: subscriberId, tokenApi: token });
  }
}
